import React from 'react'
import styled from 'styled-components'
import Color from './color'
import Font from './font'
import Size from './size'
import Stroke from './stroke'

const Container = styled.div`
    display: flex;
    grid-column: span 8;
    margin: -20px -15px 0;
    > div {
        margin-right: 10px;
    }
    > div:last-child {
        margin-right: 0;
    }
`

const CreationSourceEditorCaptionDropdowns = () => {
    return (
        <Container>
            <Font />
            <Size />
            <Color />
            <Stroke />
        </Container>
    )
}

export default CreationSourceEditorCaptionDropdowns
